import axios from 'axios';
import { getActiveStoreId } from '../lib/storefront/storeBootstrap.js';
import { pickLocalized } from '../utils/localizedContent.js';
import { resolveMediaUrl } from '../utils/mediaUrl.js';

const API_URL = process.env.REACT_APP_API_BASE_URL;

export async function fetchTestimonials(storeId = getActiveStoreId()) {
    const response = await axios.get(`${API_URL}/api/testimonials`, {
        headers: storeId ? { 'X-Store-Id': storeId } : undefined,
    });
    return Array.isArray(response.data) ? response.data : [];
}

export function mapTestimonialRecord(item, languageKey = 'en') {
    if (!item) return null;

    return {
        id: item._id || item.id,
        name: item.authorName || '',
        role: item.authorTitle || '',
        message: pickLocalized(item.quote, languageKey),
        avatarUrl: resolveMediaUrl(item.avatarUrl),
        rating: Math.min(5, Math.max(1, Number(item.rating) || 5)),
        isFeatured: Boolean(item.isFeatured),
    };
}

export function sortTestimonials(items = []) {
    return [...items].sort((a, b) => {
        if (a.isFeatured !== b.isFeatured) {
            return Number(b.isFeatured) - Number(a.isFeatured);
        }
        return 0;
    });
}
